"use client";

import { getLabel, SORT } from "@/constants/sort.constant";
import useUrlParams from "@/hooks/url";
import { Tab, Tabs } from "@mui/material";
import { SyntheticEvent } from "react";

export default function Sort() {
  const { updateURLParams, searchParams } = useUrlParams();
  const sort = searchParams.get("sort") || SORT.NEWEST;
  const handleChange = (_: SyntheticEvent<Element, Event>, value: string) => {
    updateURLParams({ sort: value });
  };

  return (
    <div className="border-b border-zinc-200 px-4 pt-4">
      <div className="text-lg font-semibold">
        Showing results for "{searchParams.get("q")}"
      </div>
      <div className="flex items-center gap-x-6">
        <div className="font-semibold">Sort By</div>
        <Tabs value={sort} onChange={handleChange}>
          {Object.values(SORT).map((value, index) => (
            <Tab key={index} label={getLabel(value)} value={value} />
          ))}
        </Tabs>
      </div>
    </div>
  );
}
